import { Field, Form, Widget } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';
import {
  AUTH_FIELD,
  AUTH_FIELD_VALIDATION,
  IAR_FIELD,
  IAR_FIELD_VALIDATION,
  SIGNEE_FIELD,
  TAC_FIELD,
  TAC_FIELD_VALIDATION,
} from './constants';
import TermsAndConditionsRender from './TermsAndConditionsRender';
import useTermsAndConditionsForm from './useTermsAndConditionsForm';

const TermsAndConditionsForm: React.FunctionComponent = function () {
  const { form, onSubmit, disabled, body, isSubmitting } =
    useTermsAndConditionsForm();
  return (
    <Form
      id="terms-and-conditions"
      form={form}
      onSubmit={onSubmit}
      className="flex flex-col w-full max-w-180 mx-auto"
    >
      <TermsAndConditionsRender body={body} />
      <div className="flex flex-col w-full max-w-120 mx-auto">
        <Widget.CompanyCompanyInfoContractAgreementPrintName
          {...SIGNEE_FIELD}
        />
        <Field.Validator validation={AUTH_FIELD_VALIDATION}>
          <Field.BooleanInput {...AUTH_FIELD} />
        </Field.Validator>
        <div className="mb-6">
          <Field.Validator validation={TAC_FIELD_VALIDATION}>
            <Field.FingerprintBooleanInput {...TAC_FIELD} />
          </Field.Validator>
        </div>
        <Field.Validator validation={IAR_FIELD_VALIDATION}>
          <Field.BooleanInput {...IAR_FIELD} />
        </Field.Validator>
        <Button.Text
          submit
          id="onboarding-terms-sign"
          disabled={disabled}
          label="Sign"
          left
          icon="check"
        />
        <Loader isLoading={isSubmitting} />
      </div>
    </Form>
  );
};

export default TermsAndConditionsForm;
